import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

type TestWebhookParams = {
	event: string;
	webhookId: string;
};

/**
 * TODO: we could just send it from the client,
 * instead of the backend?
 */
export default function useTestWebhook(shop: ShopDto) {
	return useApiMutation(
		"post",
		"/shops/{shopId}/webhooks/{webhookId}/{event}/test",
		{
			mapVariables: ({ event, webhookId }: TestWebhookParams) => ({
				params: { path: { shopId: shop.id, webhookId, event } },
			}),
		},
	);
}
